jQuery(document).ready(function($) {
	if (!window.WebAssessmentCharts) {
		window.WebAssessmentCharts = {}; // Create namespace if it doesn't exist
	}

	// Strips the `SAMA-CRFR-<major>-<minor>-` framework/version prefix so that
	// numeric control IDs like `SAMA-CRFR-1-0-3.3.5` become `3.3.5` and can be
	// treated the same way numeric CIS safeguard IDs are.
	const SAMA_CRFR_PREFIX_REGEX = /^SAMA-CRFR-\d+-\d+-/i;
	function stripSamaCrfrPrefix(controlId) {
		if (typeof controlId !== 'string') {
			return controlId;
		}
		return controlId.replace(SAMA_CRFR_PREFIX_REGEX, '');
	}

	// Extracts the top-level numeric domain (e.g. "3" from "3.3.5")
	function getSamaCrfrCategory(controlId) {
		const numericId = stripSamaCrfrPrefix(controlId);
		if (!numericId) {
			return null;
		}
		return numericId.split('.')[0];
	}

	let projectID;
	if ($('body').hasClass('single-projects')) {
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			projectID = pathParts[1].split('/')[0];
			console.log('Extracted projectID:', projectID);
		}
	}

	WebAssessmentCharts.fetchProjectChartData = fetchProjectChartData;
	var homeFrameworkProcessUniqueItems = processUniqueItemsCIS;

	// Fetch project data and standard data, then process them together
	WebAssessmentCharts.fetchDataAndCalculateScores = async function (projectID) {
		const pathParts = window.location.pathname.split('/projects/');
		if (pathParts.length > 1) {
			projectID = pathParts[1].split('/')[0];
		}

		try {
			const projectDataPromise = WebAssessmentCharts.fetchProjectChartData(projectID);
			const [projectData] = await Promise.all([projectDataPromise]);

			if (!projectData || !Array.isArray(projectData)) {
				console.error('Project data is missing or not structured as expected:', projectData);
				return;
			}

			const projectItems = projectData;
			const processedItems = homeFrameworkProcessUniqueItems(projectItems);
			console.log('Processed Items:', processedItems);

			// Fetch SAMA CRFR standards data
			try {
				const response = await jQuery.ajax({
					url: controlsData.ajax_url,
					type: 'POST',
					dataType: 'json',
					data: {
						action: 'api_action',
						year: '2024',
						apis: ['CS'],
						CSLstandardID: 'SAMA-CRFR-1-0'
					}
				});

				console.log('SAMA CRFR Standards response structure:', JSON.stringify(response, null, 2));
				WebAssessmentCharts.samaCrfrStandardData = response;

				if (!response.CS || !response.CS.Items) {
					console.error('Invalid SAMA CRFR standards response structure:', response);
					return;
				}

				WebAssessmentCharts.SAMACRFR(processedItems, response);

			} catch (error) {
				console.error('Error fetching SAMA CRFR standards:', error);
				WebAssessmentCharts.SAMACRFR(processedItems);
			}

		} catch (error) {
			console.error('Error processing data:', error);
		} finally {
			$('.modal-body .loader').hide();
		}
	};

	if (typeof WebAssessmentCharts.registerHomeDashboardFetcher === 'function') {
		WebAssessmentCharts.registerHomeDashboardFetcher('sama-crfr-1-0', WebAssessmentCharts.fetchDataAndCalculateScores);
	}

	WebAssessmentCharts.calculateMaturityScore = calculateMaturityScore;
	WebAssessmentCharts.getMostRecentSafeguards = getMostRecentSafeguards;
	WebAssessmentCharts.processUniqueItems = processUniqueItemsCIS;

	WebAssessmentCharts.calculateSamaCrfrCategoryAverages = function(items, standardData) {
		const categoryScores = {};
		const categoryPotentialCounts = {};

		if (standardData && standardData.CS && standardData.CS.Items) {
			standardData.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					const category = getSamaCrfrCategory(control.controlid.S);
					if (category === null || category === undefined) {
						return;
					}
					if (!categoryPotentialCounts[category]) {
						categoryPotentialCounts[category] = 0;
					}
					categoryPotentialCounts[category]++;
				}
			});
		}
		console.log('SAMA CRFR Category potential counts: ', categoryPotentialCounts);

		Object.keys(categoryPotentialCounts).forEach(category => {
			categoryScores[category] = {
				total: 0,
				count: 0,
				notApplicableCount: 0,
				totalItems: 0,
				potentialCount: categoryPotentialCounts[category]
			};
		});

		items.forEach(item => {
			if (!item.safeguardid || !item.safeguardid.S) {
				return;
			}
			const category = getSamaCrfrCategory(item.safeguardid.S);
			if (category === null || category === undefined) {
				return;
			}
			const maturityScore = item.maturityscore;
			const policyStatus = item.policystatus ? item.policystatus.N : null;

			if (!categoryScores[category]) {
				categoryScores[category] = {
					total: 0,
					count: 0,
					notApplicableCount: 0,
					totalItems: 0,
					potentialCount: categoryPotentialCounts[category] || 0
				};
			}

			categoryScores[category].totalItems++;

			if (policyStatus === "1") {
				categoryScores[category].notApplicableCount++;
			} else if (maturityScore !== null) {
				categoryScores[category].total += maturityScore;
				categoryScores[category].count++;
			}
		});

		const averages = {};
		Object.keys(categoryScores).forEach(category => {
			const { total, count, notApplicableCount, totalItems, potentialCount } = categoryScores[category];

			if (notApplicableCount === totalItems && totalItems > 0) {
				averages[category] = null;
			} else {
				const applicableCount = potentialCount ? (potentialCount - notApplicableCount) : count;
				averages[category] = applicableCount > 0 ? total / applicableCount : 0;
				console.log(`SAMA CRFR Category ${category}: total=${total}, potentialCount=${potentialCount}, notApplicableCount=${notApplicableCount}, applicableCount=${applicableCount}, average=${averages[category]}`);
			}
		});

		console.log('SAMA CRFR Category averages: ', averages);
		return averages;
	};

	WebAssessmentCharts.SAMACRFR = function(items, standardData) {
		console.log('Starting SAMACRFR function...');
		const tableBody = document.querySelector('#sama-crfr tbody');
		if (!tableBody) {
			console.error('SAMA CRFR Table body not found.');
			return;
		}

		const originalIndices = new Map();
		Array.from(tableBody.rows).forEach((row, index) => {
			originalIndices.set(row, index);
		});

		const allSafeguards = new Map();
		if (standardData && standardData.CS && standardData.CS.Items) {
			standardData.CS.Items.forEach(control => {
				if (control.controlid && control.controlid.S) {
					allSafeguards.set(control.controlid.S, {
						safeguardid: { S: control.controlid.S },
						policystatus: { N: "0" },
						maturityscore: 0
					});
				}
			});
		}

		const processedItems = homeFrameworkProcessUniqueItems(items);
		processedItems.forEach(item => {
			if (item && item.safeguardid && item.safeguardid.S) {
				allSafeguards.set(item.safeguardid.S, item);
			}
		});

		const mergedItems = Array.from(allSafeguards.values());
		console.log('SAMA CRFR merged items (including unanswered):', mergedItems);

		const averageScores = WebAssessmentCharts.calculateSamaCrfrCategoryAverages(mergedItems, standardData);

		const rowsToRemove = [];

		Array.from(tableBody.rows).forEach(row => {
			row.style.display = '';
		});

		// Update the table: top-level domain number -> row index (1 -> row 0, 2 -> row 1, ...)
		Object.keys(averageScores).forEach(category => {
			const rowIndex = parseInt(category, 10) - 1;
			const row = tableBody.rows[rowIndex];
			if (row) {
				const averageScore = averageScores[category];
				const scoreCell = row.cells[1];

				if (averageScore === null) {
					rowsToRemove.push(row);
				} else {
					const scaledScore = averageScore * 5;
					scoreCell.textContent = scaledScore.toFixed(2);
					console.log(`Updated SAMA CRFR row ${rowIndex + 1} with averageScore:`, scaledScore.toFixed(2));
				}
			} else {
				console.warn(`SAMA CRFR row not found for category ${category} with rowIndex ${rowIndex}`);
			}
		});

		rowsToRemove.forEach(row => {
			row.remove();
		});

		let totalScore = 0;
		let scoreCount = 0;
		Array.from(tableBody.rows).forEach((row) => {
			const scoreText = row.cells[1].textContent;
			const score = parseFloat(scoreText);
			if (!isNaN(score)) {
				totalScore += score;
				scoreCount++;
			}
		});

		const maturityRatingRow = $('#sama-crfr .light-background td');
		if (maturityRatingRow.length > 0 && scoreCount > 0) {
			const overallMaturity = totalScore / scoreCount;
			WebAssessmentCharts.overallSAMACRFRmaturity = overallMaturity;

			maturityRatingRow.text(overallMaturity.toFixed(2));
			$('.audit-overall-value').text(overallMaturity.toFixed(2));
			$('.sama-crfr-overall-value').text(overallMaturity.toFixed(2));
			console.log(`Updated SAMA CRFR overall maturity rating to ${overallMaturity.toFixed(2)}`);

			$('.spinner-border').hide();
			$('.mark-complete-modal-buttons').show();
		} else {
			console.error('Error: No scores found or maturity rating row not found in the SAMA CRFR table.');
		}

		$('.sama-crfr-container').show();
		WebAssessmentCharts.createChartFromTable('sama-crfr', 'sama-crfr-chart', charts, true);

		rowsToRemove.forEach(row => {
			const originalIndex = originalIndices.get(row);
			if (originalIndex !== undefined) {
				tableBody.insertBefore(row, tableBody.rows[originalIndex] || null);
				row.style.display = 'none';
			}
		});
	};

	var charts = {};

	$('a.view-table').on('click', function (e) {
		e.preventDefault();
		var $button = $(this);
		var card = $button.closest('.card');
		var dataTable = card.find('.data');
		var chart = card.find('.chart');

		var isModal = $('body').hasClass('single-projects');
		var $scrollContainer = isModal ? $('.modal.show .modal-body') : $('html, body');

		dataTable.toggle();

		setTimeout(function() {
			var $targetElement;
			var headerOffset = 20;

			if (dataTable.is(':visible')) {
				$button.text('Hide Table');
				$targetElement = dataTable;
			} else {
				$button.text('View Table');
				$targetElement = card;
			}

			var currentScrollTop = $scrollContainer.scrollTop();
			var targetTop = $targetElement[0].getBoundingClientRect().top;
			var containerTop = isModal ? $scrollContainer[0].getBoundingClientRect().top : 0;

			var scrollOffset = targetTop - containerTop - headerOffset;
			var newScrollTop = currentScrollTop + scrollOffset;

			$scrollContainer.scrollTop(newScrollTop);

		}, 10);

		jQuery('.dashboard-selection').select2('open');
		jQuery('.dashboard-selection').select2('close');
	});

	viewResultsProject = window.location.href;
	let currentProjectID = '';

	if (viewResultsProject.includes('#')) {
		currentProjectID = viewResultsProject.split('#')[1];
	}

	if (!currentProjectID) {
		const projectPath = viewResultsProject.split('/projects/');
		if (projectPath.length > 1) {
			currentProjectID = projectPath[1];
		}
	}

	$('.view-results').on('click', function() {
		$('.modal-body .loader').show();
		let projectPath = viewResultsProject.split('/projects/');
		if (projectPath.length > 1) {
			currentProjectID = projectPath[1].split(/[?#]/)[0];
			WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
		}
	});

	$(document).on('shown.bs.modal', '#projectCompleteModal', function (event) {
		if (currentProjectID) {
			console.log('Project Complete Modal detected with Project ID:', currentProjectID);
			WebAssessmentCharts.fetchDataAndCalculateScores(currentProjectID);
		} else {
			console.error('Project ID not found for #projectCompleteModal');
		}
	});
});
